import { render, staticRenderFns } from "./sanctionSearch.vue?vue&type=template&id=1e6ee229&scoped=true"
import script from "./sanctionSearch.vue?vue&type=script&lang=js"
export * from "./sanctionSearch.vue?vue&type=script&lang=js"
import style0 from "./sanctionSearch.vue?vue&type=style&index=0&id=1e6ee229&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6ee229",
  null
  
)

export default component.exports